import React, { Component } from "react";

export class Header extends Component {
  render() {
    return (
      <div>
      <header id="header">
          <img src="img/industrial.jpg" alt="electroskillsengineering" id="introBanner" />
      </header>
      </div>
    );
  }
}

export default Header;
